<template>
  <div class="chat-widget" :class="{ 'chat-widget--open': isOpen }">
    <div class="chat-widget__options">
      <a
        v-if="contactMap.whatsapp"
        class="chat-widget__option chat-widget__option--whatsapp"
        @click.prevent="openContact('whatsapp')"
      >
        <svg
          t="1764591435670"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2561"
          width="40"
          height="40"
          style="z-index: 11111;"
        >
          <path
            d="M849.92 51.2H174.08c-67.8656 0-122.88 55.0144-122.88 122.88v675.84c0 67.8656 55.0144 122.88 122.88 122.88h675.84c67.8656 0 122.88-55.0144 122.88-122.88V174.08c0-67.8656-55.0144-122.88-122.88-122.88z m-337.90464 768.01024h-0.11776c-55.12704-0.02048-109.20448-14.81216-156.35456-42.80832l-11.23328-6.65088-116.27008 30.47936 31.04768-113.31072-7.31648-11.6224A306.42176 306.42176 0 0 1 204.8 511.85152c0.0768-169.3184 137.8816-307.06176 307.31264-307.06176 82.06848 0.02048 159.1808 32.00512 217.18528 90.05056 58.0096 58.04544 89.91744 135.21408 89.90208 217.26208-0.06144 169.34912-137.86112 307.10784-307.18464 307.10784z"
            fill="#40C351"
            p-id="2562"
          ></path>
          <path
            d="M680.4992 589.2096c-9.23136-4.62848-54.64064-26.96192-63.10912-30.0288s-14.6176-4.608-20.79232 4.62848c-6.15424 9.23136-23.84384 30.03904-29.24032 36.18816-5.39136 6.1696-10.7776 6.94784-20.01408 2.31936-9.22112-4.63872-38.96832-14.37184-74.26048-45.82912-27.44832-24.46848-45.9776-54.69696-51.37408-63.94368-5.39136-9.22624-0.58368-14.22848 4.04992-18.8416 4.1472-4.1472 9.22624-10.78272 13.85984-16.1792 4.61312-5.39136 6.15424-9.24672 9.22624-15.39584 3.07712-6.17472 1.536-11.56096-0.77824-16.1792-2.2784-4.6336-20.224-50.29888-28.4416-68.56192-6.912-15.37536-14.19264-15.68768-20.79232-15.96416-5.39136-0.2304-11.54048-0.21504-17.69472-0.21504-6.14912 0-16.1536 2.31936-24.6272 11.56608-8.46848 9.24672-32.3328 31.57504-32.3328 77.00992 0 45.44 33.09056 89.344 37.70368 95.50336 4.61312 6.14912 63.89248 102.36928 157.75232 139.392 78.0032 30.76096 93.89056 24.64768 110.82752 23.11168 16.94208-1.53088 54.64064-22.31808 62.33088-43.89888 7.69536-21.56032 7.69536-40.0384 5.39648-43.88864-2.31424-3.86048-8.46336-6.15424-17.6896-10.79296z"
            fill="#40C351"
            p-id="2563"
          ></path>
        </svg>
        <span class="icon_text">whatsapp</span>
      </a>

      <a
        v-if="contactMap.messenger"
        class="chat-widget__option chat-widget__option--messenger"
        @click.prevent="openContact('messenger')"
      >
        <svg
          t="1764590797678"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1582"
          width="40"
          height="40"
          style="z-index: 11111;"
        >
          <path
            d="M481.28 404.48l-153.6 168.96 138.24-76.8 76.8 76.8L696.32 404.48 558.08 481.28z"
            fill="#448AFF"
            p-id="1583"
          ></path>
          <path
            d="M849.92 51.2H174.08c-67.8656 0-122.88 55.0144-122.88 122.88V849.92c0 67.8656 55.0144 122.88 122.88 122.88H849.92c67.8656 0 122.88-55.0144 122.88-122.88V174.08c0-67.8656-55.0144-122.88-122.88-122.88zM512 757.76c-27.64288 0-55.296-4.60288-79.87712-10.75712L312.32 819.2V682.49088C255.48288 631.80288 220.16 561.15712 220.16 481.28c0-152.064 130.56-276.48 291.84-276.48s291.84 124.416 291.84 276.48c0 152.06912-130.56 276.48-291.84 276.48z"
            fill="#448AFF"
            p-id="1584"
          ></path>
        </svg>
        <span class="icon_text">messenger</span>
      </a>
    </div>

    <button class="chat-widget__main" @click="toggle" aria-label="Chat" type="button">
      <img class="chat-widget__icon chat-widget__icon--open" src="../assets/20251223170342_2375_21.png" alt="">
      <img class="chat-widget__icon chat-widget__icon--close" src="../assets/20251223170342_2375_21.png" alt="">
    </button>
  </div>
</template>

<script>
import { listCustomerAccounts } from '@/api'
import { buildCustomerContactUrl, normalizeCustomerPlatform } from '@/utils/customer-contact'
import { LIVE_STATS_PATHS } from '@/utils/live-stats-api'

export default {
  name: 'ChatWidget',
  data() {
    return {
      contactMap: {
        whatsapp: null,
        messenger: null,
      },
    }
  },
  computed: {
    isOpen() {
      return this.$store.state.showWa
    },
  },
  mounted() {
    this.loadContacts()
  },
  methods: {
    async loadContacts() {
      try {
        const { data } = await listCustomerAccounts()
        const rows = this.extractList(data)
        const nextMap = {
          whatsapp: null,
          messenger: null,
        }

        rows.forEach((item) => {
          const platform = normalizeCustomerPlatform(item.platform)
          if (!(platform in nextMap)) return
          if (Number(item.status) !== 1) return
          if (!String(item.account || '').trim()) return
          nextMap[platform] = item
        })

        this.contactMap = nextMap
      } catch (error) {
        console.error('[chat-widget] load contacts failed', error)
      }
    },
    extractList(payload) {
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.data)) return payload.data
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.items)) return payload.items
      if (Array.isArray(payload?.rows)) return payload.rows
      if (Array.isArray(payload?.data?.data)) return payload.data.data
      return []
    },
    toggle() {
      const open = !this.isOpen
      this.$store.commit('SET_SHOWCONTACT', open)
    },
    trackContactOpen(platform) {
      if (platform === 'whatsapp') {
        if (window.visitTracker && typeof visitTracker.setExtra === 'function') {
          visitTracker.setExtra({ open_wa: true })
        }

        const patch = { type: 'patch', open_wa: true }
        if (navigator.sendBeacon) {
          const blob = new Blob([JSON.stringify(patch)], { type: 'application/json' })
          navigator.sendBeacon(LIVE_STATS_PATHS.ping || '/api/v1/visits/events/ping', blob)
        } else if (window.visitTracker && typeof visitTracker._hit === 'function') {
          visitTracker._hit(LIVE_STATS_PATHS.ping || '/api/v1/visits/events/ping', patch)
        }
        return
      }

      if (platform === 'messenger') {
        if (window.visitTracker && typeof visitTracker.setExtra === 'function') {
          visitTracker.setExtra({ open_fbmessager: true })
        }

        const patch = { type: 'patch', open_fbmessager: true }
        if (navigator.sendBeacon) {
          const blob = new Blob([JSON.stringify(patch)], { type: 'application/json' })
          navigator.sendBeacon(LIVE_STATS_PATHS.ping || '/api/v1/visits/events/ping', blob)
        } else if (window.visitTracker && typeof visitTracker._hit === 'function') {
          visitTracker._hit(LIVE_STATS_PATHS.ping || '/api/v1/visits/events/ping', patch)
        }
      }
    },
    openContact(platform) {
      const item = this.contactMap[platform]
      if (!item) return

      const url = buildCustomerContactUrl(item.platform, item.account)
      if (!url) return

      this.trackContactOpen(platform)
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
.chat-widget {
  position: relative;
}

.chat-widget__main {
  width: 90px;
  height: 35px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  background: #9b5cf6;
  color: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
  position: relative;
  outline: none;
}

.chat-widget__main:hover {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
}

.chat-widget__icon {
  position: absolute;
  font-size: 24px;
  line-height: 1;
  transition: opacity 0.2s ease, transform 0.2s ease;
  width: 90px;
  height: 35px;
  border-radius: 5px;
}

.chat-widget__icon--close {
  opacity: 0;
  transform: scale(0.7);
}

.chat-widget__options {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  max-height: 0;
  opacity: 0;
  pointer-events: none;
  transform: translate(37px, 10px);
  transition: all 0.25s ease;
  position: absolute;
}

.chat-widget__option {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  border-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #fff;
  cursor: pointer;
  transform: translateY(20px);
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
  position: relative;
}

.chat-widget__option::after {
  content: '';
  position: absolute;
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  background-color: #fff;
  z-index: 0;
}

.chat-widget__option--telegram {
  background: #29a9eb;
}

.chat-widget--open .chat-widget__options {
  max-height: 500px;
  opacity: 1;
  pointer-events: auto;
  transform: translate(57px, -90px);
}

.chat-widget--open .chat-widget__option {
  opacity: 1;
  transform: translateY(0);
}

.chat-widget--open .chat-widget__option .icon_text {
  position: absolute;
  right: calc(30px);
  top: 5px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 800;
  border-radius: 5px;
  color: #fff;
  background-color: rgb(0, 0, 0, 0.6);
}

.icon_text::after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  border-left: 5px solid rgb(0, 0, 0, 0.6);
  border-bottom: 5px solid transparent;
  border-top: 5px solid transparent;
  border-right: 5px solid transparent;
  top: 8px;
  right: -10px;
}

.chat-widget--open .chat-widget__option:nth-child(1) {
  transition-delay: 0.02s;
}

.chat-widget--open .chat-widget__option:nth-child(2) {
  transition-delay: 0.06s;
}

.chat-widget--open .chat-widget__option:nth-child(3) {
  transition-delay: 0.1s;
}

.chat-widget--open .chat-widget__icon--open {
  opacity: 0;
  transform: scale(0.7);
}

.chat-widget--open .chat-widget__icon--close {
  opacity: 1;
  transform: scale(1);
}

@media (max-width: 768px) {
  .chat-widget {
    position: relative;
  }

  .chat-widget__main {
    width: 90px;
    height: 35px;
  }

  .chat-widget__option {
    width: 35px;
    height: 35px;
  }
}
</style>
